import { Tag, Text, Tooltip } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { CegidIntegrationStatus } from '@features/cegidIntegration/enums/cegidIntegrationStatus'

import { importedInvoiceRejectCodeToTooltipKey } from '../../constants/importedInvoiceRejectCodeToTooltipKey'
import { importedInvoiceSyncStatusToTag } from './constants/importedInvoiceSyncStatusToTag'
import * as Styled from './styles'

interface ImportedInvoiceSyncStatusProps {
  rejectCode?: string
  status: CegidIntegrationStatus
}

export const ImportedInvoiceSyncStatus = ({ rejectCode, status }: ImportedInvoiceSyncStatusProps): ReactElement => {
  const { t } = useTranslation()
  const tag = importedInvoiceSyncStatusToTag[status]

  const tooltipKey =
    (status === CegidIntegrationStatus.Failed && rejectCode
      ? importedInvoiceRejectCodeToTooltipKey[rejectCode]
      : undefined) ?? tag.tooltipKey

  const label = t(tag.labelKey)

  return (
    <Styled.ImportedInvoiceSyncStatusWrapper>
      <Tooltip label={t(tooltipKey)} placement="top">
        <Tag color={tag.color} icon={tag.icon} maxWidth="100%" size="md" type="subtle">
          <Text as="span" inherit truncate>
            {label}
          </Text>
        </Tag>
      </Tooltip>
    </Styled.ImportedInvoiceSyncStatusWrapper>
  )
}
